import { render, staticRenderFns } from "./OrganizerEvents.vue?vue&type=template&id=288867de&"
import script from "./OrganizerEvents.vue?vue&type=script&lang=js&"
export * from "./OrganizerEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports